import React, { useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Field, Form, Formik } from 'formik'
import { Alert, Input } from '@wellbeingxltd/fe-lib/components'
import { formatDate, formatPrice } from '@wellbeingxltd/fe-lib/helpers'
import { ListItem } from 'components/Form/ListItem'
import { Button } from 'components'
import { AnalyticsActions } from 'store/models/analytics'
import { VouchersActions } from 'store/models/vouchers'
import styles from './styles.module.scss'

export const Voucher = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { id } = useParams()
    const {
        state: { code, createdAt, description, price, priceDesc, productId, resourceId, resourceTitle, supplierId, tag = [], updatedAt, used },
    } = useLocation()

    useEffect(() => {
        dispatch(AnalyticsActions.postAnalytics('[Voucher] componentDidMount', history.location.pathname))
    }, [])

    const onSubmit = values => {
        const body = {
            productId,
            supplierId,
            resourceId,
            existingVoucherCode: code,
            newVoucherCode: values.code,
        }

        dispatch(
            VouchersActions.updateVoucherCode(body, (message, type) => {
                Alert(message, type)
                history.push('/vouchers')
            })
        )
    }

    return (
        <>
            <div className={styles.header}>
                <div className={styles.headerBlock}>
                    <h2 className={styles.title}>Voucher</h2>
                    <div className={styles.id}>
                        <span>{id}</span>
                    </div>
                </div>
            </div>

            <div className="module">
                <Formik {...{ initialValues: { code }, onSubmit }}>
                    {({ dirty, errors, touched }) => (
                        <Form>
                            <ListItem title="Code">
                                <Field name="code">
                                    {({ field }) => (
                                        <Input
                                            className={styles.input}
                                            disabled={used}
                                            id="code"
                                            type="text"
                                            error={errors.companyName}
                                            touched={touched.companyName}
                                            {...field}
                                        />
                                    )}
                                </Field>
                            </ListItem>
                            <ListItem title="Created at" value={formatDate(createdAt)} />
                            <ListItem title="Description" value={description || priceDesc || '-'} />
                            <ListItem title="Price" value={formatPrice(price)} />
                            <ListItem title="Product ID" value={productId} />
                            <ListItem title="Resource ID" value={resourceId} />
                            <ListItem title="Resource Title" value={resourceTitle} />
                            <ListItem title="Supplier ID" value={supplierId} />
                            <ListItem title="Tag" value={tag.join(', ') || '-'} />
                            <ListItem title="Updated at" value={formatDate(updatedAt)} />

                            <Button disabled={!dirty || Object.keys(errors).length} type="submit" variant="primary">
                                Save
                            </Button>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}
